import { lazyLoad, createIcon } from "./helpers";
import { instituteRoutes, userRoutes, projectRoutes, trainingRoutes, 
    toolsRoutes, scheduleRoutes, reportRoutes, inventoryRoutes } from "./subRoutes";

const Dashboard = lazyLoad("Dashboard");
const ProjectAssistantDashboard = lazyLoad("Dashboard/ProjectAssistantDashboard");
const Profile = lazyLoad("Profile");
const Institutes = lazyLoad("Institutes");
const Users = lazyLoad("Users");
const Calendar = lazyLoad("Calendar");
const Trainings = lazyLoad("Trainings");
const Schedules = lazyLoad("Schedules");
const Projects = lazyLoad("Projects");
const Tools = lazyLoad("Tools");
const Inventory = lazyLoad("Inventory");
const Reports = lazyLoad("Reports");

const TrainingCalendarList = lazyLoad("Calendar/TrainingCalendarList");
// const TrainingCalendarCreateEdit = lazyLoad("Calendar/TrainingCalendarCreateEdit");
const TrainingCalendarMapView = lazyLoad("Calendar/TrainingCalendarMapView");
const LatestLocationMapView = lazyLoad("Calendar/LatestLocationMapView");

const FeedbackResponse = lazyLoad("FeedbackResponse");
const FeedbackResponseList = lazyLoad("FeedbackResponse/FeedbackResponseList");
const FeedbackResponseViewer = lazyLoad("FeedbackResponse/FeedbackResponseViewer");

const FeedbackForms = lazyLoad("Administrator/FeedbackForms");
const FeedbackFormList = lazyLoad("Administrator/FeedbackForms/FeedbackFormList");
const FeedbackFormBuilder = lazyLoad("Administrator/FeedbackForms/FeedbackFormBuilder");
const FeedbackQuestionViewer = lazyLoad("Administrator/FeedbackForms/FeedbackQuestionViewer");

const Resources = lazyLoad("Administrator/Resources");
const ResourceList = lazyLoad("Administrator/Resources/ResourceList");
const ResourceCreatedEdit = lazyLoad("Administrator/Resources/ResourceCreatedEdit");
const ResourceListView = lazyLoad("Administrator/Resources/ResourceListView");

const Administrator = lazyLoad("Administrator");
const TypeOfAdmin = lazyLoad("Administrator/TypeOfAdmin");
const Registration = lazyLoad("Administrator/Registration");
const RegistrationList = lazyLoad("Administrator/Registration/RegistrationList");
const RegistrationCreateEdit = lazyLoad("Administrator/Registration/RegistrationCreateEdit");


export const trainerMainRoutes = [
  {
    path: "Calendar",
    element: <Calendar />,
    icon: createIcon("calender"),    
    children: [{ path: "", element: <TrainingCalendarList /> }],
    module: ["training"],
  },
  {
    path: "Projects",
    element: <Projects />,
    icon: createIcon("project"),    
    children: projectRoutes,
    module: ["training"],
  },
  {
    path: "Trainings",
    element: <Trainings />,
    icon: createIcon("training"),    
    children: trainingRoutes,
    module: ["training"],
  },
  {
    path: "Resources",
    element: <Resources />,
    icon: createIcon("resource"),    
    children: [{ path: "", element: <ResourceListView /> }],
    module: ["training"],
  },
  {
    path: "Reports",
    element: <Reports />,
    icon: createIcon("report"),
    children: reportRoutes,
    module: ["training"],
  },
  {
    path: "Tools",
    element: <Tools />,
    icon: createIcon("repository"),
    children: toolsRoutes,
    module: ["training"],
  },
];

export const projectownerMainRoutes = [
  {
    path: "Dashboard",
    label: "Home",
    element: <Dashboard />,
    icon: createIcon("home"),
    module: ["training"],
  },
  {
    path: "Projects",
    element: <Projects />,
    icon: createIcon("project"),    
    children: projectRoutes,
    module: ["training"],
  },
  {
    path: "Institutes",
    element: <Institutes />,
    icon: createIcon("institute"),    
    children: instituteRoutes,
    module: ["training"],
  },
  {
    path: "Trainings",
    element: <Trainings />,
    icon: createIcon("training"),    
    children: trainingRoutes,
    module: ["training"],
  },
  {
    path: "Schedules",
    element: <Schedules />,
    icon: createIcon("training"),    
    children: scheduleRoutes,
    module: ["training"],
  },
  {
    path: "Calendar",
    element: <Calendar />,
    icon: createIcon("calender"),    
    children: [
      { path: "", element: <TrainingCalendarList /> },
      { path: "MapView", element: <TrainingCalendarMapView /> },
      { path: "LatestLocationMapView", element: <LatestLocationMapView /> },
    ],
    module: ["training"],
  },
  {
    path: "Reports",
    element: <Reports />,
    icon: createIcon("report"),    
    children: reportRoutes,
    module: ["training"],
  },
  {
    path: "FeedbackResponse",
    label: "Feedback",
    element: <FeedbackResponse />,
    icon: createIcon("feedback"),    
    children: [
      { path: "", element: <FeedbackResponseList /> },
      { path: "View", element: <FeedbackResponseViewer /> },
    ],
    module: ["training"],
  },
];

export const projectassistantMainRoutes = [
  {
    path: "Dashboard",
    label: "Home",
    element: <ProjectAssistantDashboard />,
    icon: createIcon("home"),
    module: ["training"],
  },
  { path: "Profile", element: <Profile />, module: ["training"] },
  {
    path: "Administrator",
    element: <Administrator />,
    icon: createIcon("administrator"),    
    children: [
      { path: "", element: <TypeOfAdmin /> },
      {
        path: "Resources",
        element: <Resources />,
        children: [
          { path: "", element: <ResourceList /> },
          { path: "Create", element: <ResourceCreatedEdit /> },
          { path: "ViewEdit", element: <ResourceCreatedEdit /> },
        ],
      },

      {
        path: "FeedbackForms",
        element: <FeedbackForms />,
        children: [
          { path: "", element: <FeedbackFormList /> },
          { path: "Create", element: <FeedbackFormBuilder /> },
          { path: "Edit", element: <FeedbackFormBuilder /> },
          { path: "View", element: <FeedbackQuestionViewer /> },
        ],
      },

      {
        path: "Registration",
        element: <Registration />,
        children: [
          { path: "", element: <RegistrationList /> },
          { path: "Create", element: <RegistrationCreateEdit /> },
          { path: "Edit", element: <RegistrationCreateEdit /> },
          { path: "View", element: <RegistrationCreateEdit /> },
        ],
      },
    ],
    module: ["training"],
  },
  {
    path: "Users",
    element: <Users />,
    icon: createIcon("user"),
    children: userRoutes,
    module: ["training"],
  },
  {
    path: "Projects",
    element: <Projects />,
    icon: createIcon("project"),    
    children: projectRoutes,
    module: ["training"],
  },
  {
    path: "Institutes",
    element: <Institutes />,
    icon: createIcon("institute"),
    children: instituteRoutes,
    module: ["training"],
  },
  {
    path: "Trainings",
    element: <Trainings />,
    icon: createIcon("training"),    
    children: trainingRoutes,
    module: ["training"],
  },
  {
    path: "Schedules",
    element: <Schedules />,
    icon: createIcon("training"),    
    children: scheduleRoutes,
    module: ["training"],
  },
  {
    path: "Calendar",
    element: <Calendar />,
    icon: createIcon("calender"),    
    children: [
      { path: "", element: <TrainingCalendarList /> },
      { path: "MapView", element: <TrainingCalendarMapView /> },
      { path: "LatestLocationMapView", element: <LatestLocationMapView /> },
    ],
    module: ["training"],
  },
  {
    path: "FeedbackResponse",
    label: "Feedback",
    element: <FeedbackResponse />,
    icon: createIcon("feedback"),    
    children: [
      { path: "", element: <FeedbackResponseList /> },
      { path: "View", element: <FeedbackResponseViewer /> },
    ],
    module: ["training"],
  },
  {
    path: "Reports",
    element: <Reports />,
    icon: createIcon("report"),    
    children: reportRoutes,
    module: ["training"],
  },
  {
    path: "Inventory",
    element: <Inventory />,
    icon: createIcon("inventory"),
    children: inventoryRoutes,
    module: ["training"],
  },
  {
    path: "Tools",
    element: <Tools />,
    icon: createIcon("repository"),    
    children: toolsRoutes,
    module: ["training"],
  }  
];
